import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

const SimXPreset = definePreset(Lara, {
  primitive: {
    simxGreen: {
      100: '#e5eaea',
      200: '#cbd5d5',
      300: '#b0c0c0',
      400: '#96abab',
      500: '#7c9696',
      600: '#637878',
      700: '#4a5a5a',
      800: '#323c3c',
      900: '#191e1e',
    },
    simxPurple: {
      100: '#d7d5d9',
      200: '#aeabb3',
      300: '#86828c',
      400: '#5d5866',
      500: '#352e40',
      600: '#2a2533',
      700: '#201c26',
      800: '#15121a',
      900: '#0b090d',
    },
    simxRed: {
      100: '#faccd5',
      200: '#f599ab',
      300: '#f06682',
      400: '#eb3358',
      500: '#e6002e',
      600: '#b80025',
      700: '#8a001c',
      800: '#5c0012',
      900: '#2e0009',
    },
  },
  semantic: {
    primary: {
      100: '{simxPurple.100}',
      200: '{simxPurple.200}',
      300: '{simxPurple.300}',
      400: '{simxPurple.400}',
      500: '{simxPurple.500}',
      600: '{simxPurple.600}',
      700: '{simxPurple.700}',
      800: '{simxPurple.800}',
      900: '{simxPurple.900}',
    },
    uiText: {
      color: '#151319',
    },
    colorScheme: {
      light: {
        focusRing: {
          shadow: '0 0 2px 2px {primary.200}',
        },
        formField: {
          focusBorderColor: '{primary.300}',
          hoverBorderColor: '{primary.300}',
        },
      },
    },
    formField: {
      borderRadius: '4px',
    },
  },
  components: {
    button: {
      colorScheme: {
        light: {
          link: {
            activeColor: '{simxGreen.700}',
            color: '{simxGreen.500}',
            hoverColor: '{simxGreen.600}',
          },
          root: {
            primary: {
              activeBackground: '{simxRed.700}',
              activeBorderColor: '{simxRed.700}',
              background: '{simxRed.500}',
              borderColor: '{simxRed.500}',
              hoverBackground: '{simxRed.600}',
              hoverBorderColor: '{simxRed.600}',
            },
          },
        },
      },
      root: {
        paddingX: '12px',
        paddingY: '8px',
      },
    },
    checkbox: {
      root: {
        background: '#fff',
        borderColor: '{simxGreen.200}',
        borderRadius: '100%',
        checkedBackground: '{simxGreen.500}',
        checkedHoverBackground: '{simxGreen.500}',
        checkedBorderColor: '{simxGreen.500}',
        checkedFocusBorderColor: '{simxGreen.500}',
        checkedHoverBorderColor: '{simxGreen.500}',
        filledBackground: '{simxGreen.500}',
        focusBorderColor: '{simxGreen.300}',
        height: '17px',
        hoverBorderColor: '{simxGreen.300}',
        width: '17px',
      },
      icon: {
        checkedColor: '#fff',
        checkedHoverColor: '#fff',
        disabledColor: '#ccc',
        color: '#fff',
        size: '12px',
      },
    },
    listbox: {
      root: {
        borderRadius: '4px',
        color: '{uiText.color}',
      },
      list: {
        gap: '2px',
        padding: '2px',
      },
      option: {
        borderRadius: '4px',
        color: '{uiText.color}',
        focusBackground: '#f4f6f6',
        selectedBackground: 'none',
        selectedFocusBackground: '#f4f6f6',
        padding: '0.25rem 0.75rem',
      },
    },
  },
});

export { SimXPreset };
